import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=5a756963&scoped=true&lang=pug&"
import script from "./Convenios.vue?vue&type=script&lang=js&"
export * from "./Convenios.vue?vue&type=script&lang=js&"
import style0 from "./Convenios.styl?vue&type=style&index=0&id=5a756963&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a756963",
  null
  
)

export default component.exports